import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DecimalPipe} from "@angular/common";

@Component({
  selector: 'app-sanierung-introduction',
  templateUrl: './sanierung-introduction.component.html',
  providers: [DecimalPipe]
})
export class SanierungIntroductionComponent  {
  /**
   * factor to be used to display the chart bars
   */
  barFactor: number = 1;

  /**
   * curent consumption
   */
  current: number;

  /**
   * sanizized consumption
   */
  sanitized: number;

  /**
   * placeholders for the text
   */
  placeholder: {percent: string, sign: string, co2_current: string, co2_sanitized: string};

  /**
   * constructor
   * @param data
   * @param decimalPipe
   * @param dialogRef
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {path: string, case: number, current:number, sanitized: number, unit: string, co2_current: number, co2_sanitized: number}, private decimalPipe: DecimalPipe, private dialogRef: MatDialogRef<SanierungIntroductionComponent>) {
    // init plaxceholder
    this.placeholder = {
      percent: decimalPipe.transform((1 - (data.sanitized / data.current)) * 100, '1.0-0'),
      sign: data.sanitized > data.current? '+' : '-',
      co2_current: decimalPipe.transform(data.co2_current, '1.0-1'),
      co2_sanitized: decimalPipe.transform(data.co2_sanitized, '1.0-1'),
    };

    // set current and sanitized value
    this.current = data.current;
    this.sanitized = data.sanitized;
    if(data.unit === 'co2') {
      this.current = data.co2_current;
      this.sanitized = data.co2_sanitized;
    }

    // set barfactor after a litle timeout for a small animation
    setTimeout(() => {
      if(data.unit === 'co2') {
        this.barFactor = this.data.co2_sanitized / this.data.co2_current;
      }
      else {
        this.barFactor = this.data.sanitized / this.data.current;
      }
    }, 200);
  }

  /**
   * close the dialog
   */
  closeDialog(): void {
    this.dialogRef.close();
  }
}
